import React, { useState } from "react";
import Typography from "../../../Utility/Typography";
import Button from "../../../Utility/Button/Button";
import FormSubmitButton from "../../../Utility/Button/FormSubmitButton";
import Dropdown from "../../../Utility/Dropdown/Dropdown";
import Input from "../../../Utility/Input/Input";
import { RiCloseLine } from "react-icons/ri";

const UserRateMappingAddModel = ({
  onClose,
  onSave,
  userOptions = [],
  roleOptions = [],
  clientOptions = [],
}) => {
  const [saving, setSaving] = useState(false);
  const [form, setForm] = useState({
    user: "",
    role: "",
    client: "",
    rate: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSave = async () => {
    if (saving) return;
    if (!form.role || !form.rate) {
      alert("Please fill in Role and Rate.");
      return;
    }

    // Fallbacks so modal can be reused from User List
    const selectedUser =
      form.user || (Array.isArray(userOptions) && userOptions.length > 0 ? userOptions[0] : "");
    const selectedClient =
      form.client ||
      (Array.isArray(clientOptions) && clientOptions.length > 0 ? clientOptions[0] : "");

    const rateNumber = Number(form.rate);
    if (Number.isNaN(rateNumber) || rateNumber <= 0) {
      alert("Please enter a valid positive number for Rate.");
      return;
    }

    setSaving(true);
    try {
      await Promise.resolve(
        onSave({
          user: selectedUser,
          role: form.role,
          client: selectedClient,
          rate: rateNumber,
        })
      );
      onClose();
    } finally {
      setSaving(false);
    }
  };

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-50 z-[9999] flex items-center justify-center p-4"
      onClick={onClose}
    >
      <div
        className="bg-surface-primary rounded-lg shadow-lg w-full max-w-md"
        onClick={(e) => e.stopPropagation()}
      >
        {/* HEADER */}
        <div className="flex items-center justify-between p-4 border-b">
          <Typography variant="h5" className="font-semibold">
            Add User Rate Mapping
          </Typography>
          <Button
            variant="outline"
            size="sm"
            onClick={onClose}
            className="!text-text-secondary hover:!text-text-primary transition-colors !border-0 !shadow-none !bg-transparent !p-0 !px-0 !py-0 !font-normal !inline-flex !items-center !justify-center disabled:opacity-50 disabled:cursor-not-allowed"
          >
            <RiCloseLine className="w-5 h-5" />
          </Button>
        </div>

        {/* BODY */}
        <div className="p-4 space-y-4">
          <Dropdown
            label="Role"
            name="role"
            value={form.role}
            options={roleOptions}
            onChange={handleChange}
            searchable
            placeholder="Select Role"
          />

          <Input
            label="Rate ($/hr)"
            name="rate"
            type="number"
            value={form.rate}
            onChange={handleChange}
            placeholder="Enter Rate"
            min="0"
            className="h-9 py-1"
          />
        </div>

        {/* FOOTER */}
        <div className="flex justify-end gap-2 p-4 border-t">
          <Button variant="" className="btn-reset" onClick={onClose} disabled={saving}>
            Cancel
          </Button>
          <FormSubmitButton
            type="button"
            onClick={handleSave}
            loading={saving}
            label="Save Mapping"
            loadingText="Saving..."
            idleIconClass=""
          />
        </div>
      </div>
    </div>
  );
};

export default UserRateMappingAddModel;
